import { useMemo, useRef } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { ChartData, ChartOptions } from 'chart.js';
import { ChartComponentProps, DoughnutChartHookReturn } from './types';
import { generateBasicChartData } from './dataUtils';
import { createChartOptions } from './chartConfig';
import { AggregatedOrderViewType } from 'src/gql/graphql';

export const useDoughnutChart = ({
  table,
  grouping,
  rowSelection,
  setRowSelection,
  borderColor,
  textColor,
}: ChartComponentProps): DoughnutChartHookReturn => {
  const chartRef = useRef<any>(null);

  const chartData = useMemo(() => {
    return generateBasicChartData(
      table,
      grouping,
      rowSelection,
      AggregatedOrderViewType.DoughnutChart
    ) as ChartData<'doughnut'>;
  }, [
    table.options.data,
    table.getState().columnFilters,
    table.getState().grouping,
    grouping,
    rowSelection,
  ]);

  const chartOptions = useMemo((): ChartOptions<'doughnut'> => {
    return createChartOptions(
      AggregatedOrderViewType.DoughnutChart,
      borderColor,
      textColor,
      table,
      rowSelection,
      setRowSelection
    ) as ChartOptions<'doughnut'>;
  }, [
    borderColor,
    textColor,
    table.options.data,
    table.getState().columnFilters,
    table.getState().grouping,
    rowSelection,
    setRowSelection,
  ]);

  return {
    chartData,
    chartOptions,
    chartRef,
  };
};

export default function DoughnutChart(props: ChartComponentProps) {
  const { chartData, chartOptions, chartRef } = useDoughnutChart(props);

  return (
    <Doughnut data={chartData} options={chartOptions} ref={chartRef as any} />
  );
}
